import React from "react";

function PackageIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 160 133"
      width="160"
      height="133"
      opacity="0.7"
    >
      {/* Background circle */}
      <circle cx="80" cy="67" r="40" fill="#F5F7F9" />

      {/* Back package */}
      <g transform="translate(57, 40)">
        {/* Side panel */}
        <path d="M0 0 L7 -3 L53 -3 L47 0 Z" fill="#D6EEFF" />
        {/* Right panel */}
        <path d="M47 0 L53 -3 L53 50 L47 53 Z" fill="#B5E3FF" />
        {/* Front panel */}
        <rect x="0" y="0" width="47" height="53" rx="2" fill="#EDF8FF" />
        {/* Content lines */}
        <rect
          x="7"
          y="10"
          width="27"
          height="3"
          rx="1.5"
          fill="#0063FF"
          opacity="0.3"
        />
        <rect
          x="7"
          y="17"
          width="20"
          height="3"
          rx="1.5"
          fill="#0063FF"
          opacity="0.3"
        />
      </g>

      {/* Middle package */}
      <g transform="translate(50, 50)">
        {/* Side panel */}
        <path d="M0 0 L7 -3 L53 -3 L47 0 Z" fill="#48BAFF" />
        {/* Right panel */}
        <path d="M47 0 L53 -3 L53 50 L47 53 Z" fill="#1E97FF" />
        {/* Front panel */}
        <rect x="0" y="0" width="47" height="53" rx="2" fill="#83D4FF" />
        {/* Content lines */}
        <rect
          x="7"
          y="10"
          width="27"
          height="3"
          rx="1.5"
          fill="#0063FF"
          opacity="0.3"
        />
        <rect
          x="7"
          y="17"
          width="20"
          height="3"
          rx="1.5"
          fill="#0063FF"
          opacity="0.3"
        />
      </g>

      {/* Front package */}
      <g transform="translate(63, 60)">
        {/* Side panel */}
        <path d="M0 0 L7 -3 L53 -3 L47 0 Z" fill="#0677FF" />
        {/* Right panel */}
        <path d="M47 0 L53 -3 L53 50 L47 53 Z" fill="#084CC5" />
        {/* Front panel */}
        <rect x="0" y="0" width="47" height="53" rx="2" fill="#0063FF" />
        {/* Content lines */}
        <rect
          x="7"
          y="10"
          width="27"
          height="3"
          rx="1.5"
          fill="#F5F7F9"
          opacity="0.5"
        />
        <rect
          x="7"
          y="17"
          width="20"
          height="3"
          rx="1.5"
          fill="#F5F7F9"
          opacity="0.5"
        />
      </g>
    </svg>
  );
}

export default PackageIcon;
